import { API_BASE_URL } from "../../config";

async function fetchDeepPermits() {
  try {
    const response = await fetch(`${API_BASE_URL}/deepPermits/summary`);
    const data = await response.json();
    return Array.isArray(data) ? data : [data]; // Ensure we always return an array
  } catch (error) {
    console.error('Error fetching DEEP data:', error);
    return [];
  }
}

async function fetchBizDynamics() {
  try {
    const response = await fetch(`${API_BASE_URL}/bizDynamics`);
    const data = await response.json();
    return Array.isArray(data) ? data : [data]; // Ensure we always return an array
  } catch (error) {
    console.error('Error fetching business dynamics data:', error);
    return [];
  }
}

// Initialize with empty arrays to prevent filter errors during initial load
export const deepPermits = await fetchDeepPermits() || [];
export const bizDynamics = await fetchBizDynamics() || [];